import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth';
import { Loading } from './ui';
import { StaffLogin } from './pages/StaffLogin';
import { OperatorShell } from './operator/Shell';
import { DriverApp } from './driver/DriverApp';
import { ClientApp } from './client/ClientApp';

export function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Кабинет клиента живёт отдельно: у него своя авторизация по коду
            и своя вёрстка под телефон */}
        <Route path="/client/*" element={<ClientApp />} />
        {/* Приложение водителя — тоже отдельная ветка: оно ставится на
            домашний экран и открывается сразу в маршрут дня */}
        <Route path="/driver/*" element={<StaffOnly><DriverApp /></StaffOnly>} />
        <Route path="/login" element={<StaffLogin />} />
        <Route path="/*" element={<StaffOnly><OperatorShell /></StaffOnly>} />
      </Routes>
    </AuthProvider>
  );
}

function StaffOnly({ children }: { children: React.ReactNode }) {
  const { me, loading } = useAuth();
  if (loading) return <Loading what="Проверяю доступ" />;
  if (!me || me.scope !== 'staff') return <Navigate to="/login" replace />;
  return <>{children}</>;
}
